import request from '@utils/request'

const TEMPLATE_BASE_URL = '/api_v3/studio/component-block'
export const getComponentTemplate = params => request({
    url: TEMPLATE_BASE_URL,
    method: 'get',
    params,
})

export const addComponentTemplate = data => request({
    url: TEMPLATE_BASE_URL,
    method: 'post',
    data,
})

export const editComponentTemplate = data => request({
    url: `${TEMPLATE_BASE_URL}`,
    method: 'put',
    data,
})

export const deleteComponentTemplate = id => request({
    url: `${TEMPLATE_BASE_URL}/${id}`,
    method: 'delete',
})
